import { Button, FlexItem, Label, SegmentedControl, Switch } from '@busybusy/webapp-react-ui';
import { ChevronLeftIcon, ChevronRightIcon } from 'assets/icons';
import classNames from 'classnames';
import IconButton from 'components/foundation/buttons/IconButton/IconButton';
import ConditionalContainer from 'components/foundation/ConditionalContainer/ConditionalContainer';
import Typography from 'components/foundation/text/Typography/Typography';
import { DateTime } from 'luxon';
import { FunctionComponent, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { CalendarView } from '../types/CalendarTypes';
import './CalendarToolbar.scss';

export type CalendarNavigationAction = 'PREV' | 'NEXT' | 'TODAY';

export interface ICalendarToolbarProps {
  date: DateTime;
  label: string;
  view: CalendarView;
  onView: (view: CalendarView) => void;
  onNavigate: (value: 'PREV' | 'NEXT' | 'TODAY', date?: Date) => void;
  className?: string | object;
}

const CalendarToolbar: FunctionComponent<ICalendarToolbarProps> = (props) => {
  const { label, view, onView, onNavigate, className } = props;

  const [t] = useTranslation();

  function navigateBackward() {
    onNavigate('PREV');
  }

  function navigateForward() {
    onNavigate('NEXT');
  }

  function navigateToday() {
    onNavigate('TODAY');
  }

  const classes = classNames('calendar-toolbar', className);

  return (
    <div className={classes}>
      <div>
        <IconButton svg={ChevronLeftIcon} onClick={navigateBackward} />
        <IconButton svg={ChevronRightIcon} onClick={navigateForward} />
        <Button className="ml-4" type="secondary" onClick={navigateToday}>
          {t('Today')}
        </Button>
      </div>

      <Label className="calendar-title">{label}</Label>
      <SegmentedControl
        value={view}
        options={[
          {
            value: 'month',
            label: t('Month'),
          },
          {
            value: 'week',
            label: t('Week'),
          },
          {
            value: 'day',
            label: t('Day'),
          },
        ]}
        onChange={onView}
      />
    </div>
  );
};

export default CalendarToolbar;
